import { render } from "./Servicestatus.vue?vue&type=template&id=8531615a"
import script from "./Servicestatus.vue?vue&type=script&lang=js"
export * from "./Servicestatus.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__